import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext';

export default function PaymentCancelledPage() {
  const { language } = useLanguage();
  const { isAuthenticated } = useAuth();

  const translations = {
    en: {
      title: "Payment not completed",
      body1: "No problem — you can continue using PaperPal for free.",
      body2: "You can upgrade anytime when you're ready.",
      cta: "Back to PaperPal",
      micro: "Get full guidance whenever you need it."
    },
    fr: {
      title: "Paiement non complété",
      body1: "Pas de souci — vous pouvez continuer à utiliser PaperPal gratuitement.",
      body2: "Vous pouvez passer à la version premium quand vous le souhaitez.",
      cta: "Retour à PaperPal",
      micro: "Accédez au guide complet quand vous en avez besoin."
    }
  };

  const tr = translations[language] || translations.en;

  // Redirect destination based on auth state
  const redirectTo = isAuthenticated ? '/dashboard' : '/';

  return (
    <div className="min-h-screen bg-pp-bg flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className="w-full max-w-[520px] text-center"
      >
        {/* Title */}
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-pp-text mb-6">
          {tr.title}
        </h1>

        {/* Body Text */}
        <div className="space-y-1 mb-8">
          <p className="text-lg text-pp-text-secondary">
            {tr.body1}
          </p>
          <p className="text-lg text-pp-text-secondary">
            {tr.body2}
          </p>
        </div>

        {/* Primary Button */}
        <Link
          to={redirectTo}
          className="block w-full py-4 px-6 bg-pp-navy text-white text-center font-medium rounded-xl hover:bg-pp-navy-hover transition-colors"
          data-testid="cancelled-cta"
        >
          {tr.cta}
        </Link>

        {/* Micro Text */}
        <p className="mt-3 text-sm text-pp-text-muted">
          {tr.micro}
        </p>
      </motion.div>
    </div>
  );
}
